module.exports = __webpack_public_path__ + "img/couples-045.96d1d9a6.jpg";